import React, { FunctionComponent, useState } from 'react';
import { map } from 'ramda';
import { FormattedMessage } from 'react-intl';
import { IBindingCallback1 } from '../../common/models/callback';
import CheckboxList from '../CheckboxList';
import { RoleType } from '../../common/enums/RoleType';
import RegularButton from '../RegularButton';
import { getRoleNodes } from '../../common/helpers/nodesHelper';
import styles from './styles.module.scss';

interface IProps {
  selectedRole?: RoleType;
  onSelect: IBindingCallback1<RoleType>;
}

const RoleList: FunctionComponent<IProps> = ({
  selectedRole,
  onSelect
}) => {
  const [selected, setSelected] = useState(selectedRole);
  const items = map(({ value, label }) => ({ value, label: <FormattedMessage {...label} /> }), getRoleNodes());

  return (
    <div className={styles.roleList}>
      <main className={styles.roleListBody}>
        <CheckboxList
          total={items.length}
          items={items}
          onSelect={([role]) => setSelected(role as RoleType)}
          defaultChecked={selectedRole && [selectedRole]}
        />
      </main>
      <footer className={styles.footer}>
        <RegularButton
          textIntlId="apply"
          defaultMessage="Apply"
          size="sm"
          disabled={!selected || selectedRole === selected}
          onClick={() => onSelect(selected as RoleType)}
        />
      </footer>
    </div>
  );
};

export default RoleList;
